import script from "./PoliticaTermosDeUso.vue?vue&type=script&setup=true&lang=js"
export * from "./PoliticaTermosDeUso.vue?vue&type=script&setup=true&lang=js"

import "@/assets/legal.css?vue&type=style&index=0&id=31a0bd93&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31a0bd93"]])

export default __exports__